import { Mapper } from "../../../../lib/utils/mapper";
import { CmsSubscriptionCachedDatasource } from "../datasources/cms-subscription-cached.datasource";
import type { ICmsSubscriptionCachedDatasource } from "../datasources/cms-subscription-cached.datasource.interface";
import { CmsSubscriptionRemoteDatasource } from "../datasources/cms-subscription-remote.datasource";
import type { ICmsSubscriptionRemoteDatasource } from "../datasources/cms-subscription-remote.datasource.interface";
import { CmsSubscription } from "../entities/cms-subscription/cms-subscription.entity";
import type { ICmsSubscription } from "../entities/cms-subscription/cms-subscription.entity.interface";
import type { ICmsSubscriptionRepository } from "./cms-subscription.repository.interface";

export class CmsSubscriptionRepository implements ICmsSubscriptionRepository {
  constructor(
    private readonly _remoteDatasource: ICmsSubscriptionRemoteDatasource = new CmsSubscriptionRemoteDatasource(),
    private readonly _cachedDatasource: ICmsSubscriptionCachedDatasource = new CmsSubscriptionCachedDatasource()
  ) {}

  public async getOrderedSubscriptions(): Promise<ICmsSubscription[]> {
    const cachedSubscriptions = this._cachedDatasource.getOrderedSubscriptions();
    if (cachedSubscriptions) {
      const mappedSubscriptions = Mapper.mapArrayData(CmsSubscription, cachedSubscriptions);
      return mappedSubscriptions;
    }

    const remoteSubscriptions = await this._remoteDatasource.getOrderedSubscriptions();
    this._cachedDatasource.setOrderedSubscriptions(remoteSubscriptions);

    const remoteEntities = Mapper.mapArrayData(CmsSubscription, remoteSubscriptions);
    return remoteEntities;
  }
}
